<script setup>
import { SecondaryButton } from "@Components/Button";
import { FormCheckbox, FormInput } from "@Components/Form";
import { PlusIcon, TrashIcon } from "lucide-vue-next";
import { watch } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
    modelValue: {
        type: Array,
        default: [],
    },
});

const emit = defineEmits(["update:modelValue"]);

const { t: __ } = useI18n();

const addEmptyLink = () => {
    props.modelValue.push({
        url: "",
        anchor: "",
        blank: false,
        nofollow: false,
    });
};

const removeLink = (index) => {
    props.modelValue.splice(index, 1);
};

watch(
    () => props.modelValue,
    (value) => {},
    { immediate: true, deep: true }
);
</script>

<template>
    <div>
        <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">{{ __("Liens personnalisés") }}</div>
        <div class="flex flex-col gap-3 mt-2">
            <div v-for="(link, index) in modelValue" :key="index" class="space-y-3">
                <div class="flex justify-end items-center gap-3">
                    <SecondaryButton @click.prevent="removeLink(index)" :z="1">
                        <TrashIcon class="w-4 h-4" />
                    </SecondaryButton>
                </div>
                <div class="grid grid-cols-12 gap-3">
                    <div class="col-span-4">
                        <FormInput v-model="link.anchor" :placeholder="__('Ancre')" />
                    </div>
                    <div class="col-span-8">
                        <FormInput v-model="link.url" :placeholder="__('URL')" />
                    </div>
                </div>

                <div class="flex items-center gap-3">
                    <label class="flex items-center gap-2">
                        <FormCheckbox v-model="link.blank" />
                        <span class="text-sm">{{ __("Blank") }}</span>
                    </label>
                    <label class="flex items-center gap-2">
                        <FormCheckbox v-model="link.nofollow" />
                        <span class="text-sm">{{ __("No follow") }}</span>
                    </label>
                </div>
            </div>
            <SecondaryButton @click.prevent="addEmptyLink" :z="1" class="justify-center" :icon="PlusIcon" />
        </div>
    </div>
</template>
